export default `
  mutation UploadFileReport(
    $fileBase64: String!,
    $filename: String!,
    $dateFrom: String,
    $dateTo: String,
    $lang: String!,
    $country: [String!]!,
    $auditor: [String!]!,
    $state: [String!]!,
    $currency: [String],
    $columns: [String]
  ) {
    uploadFileReport(
      fileBase64: $fileBase64,
      filename: $filename,
      dateFrom: $dateFrom,
      dateTo: $dateTo,
      lang: $lang,
      country: $country,
      auditor: $auditor,
      state: $state,
      currency: $currency,
      columns: $columns
    ) { key filename size uploadedAt }
  }
`;


